{
    "ACDStatusHotKeys_Success_Available": "O agente \"{}\" está disponível",
    "ACDStatusHotKeys_Success_Unavailable": "O agente \"{}\" está indisponível",
    "ACDStatusHotKeys_Error_CannotSetUserToAvailable": "Não foi possível definir \"{}\" como indisponível.\nEste agente poderá já estar indisponível ou ter a sessão terminada.",
    "ACDStatusHotKeys_Error_CannotSetUserToUnavailable": "Não foi possível definir \"{}\" como indisponível.\nEste agente poderá já estar indisponível ou ter a sessão terminada.",
    "NAME": "ACDEstadoHotKeys"
}